import { useJournalEntryStore } from "@/stores/models/journal";

export default async function entryExists({ to }) {
    let exists = false;
    let id = to.params.entryId;
    if (id) {
        try {
            const store = useJournalEntryStore();
            let existing = store.item(id);
            if (!existing) {
                await store.fetchItem({
                    query: { id: id, includes: ['tags','attachments','user','users.avatar', 'class'] },
                    key: "VIEW_ENTRY"
                });
            }

            exists = true;
        } catch (err) {
            exists = false;
        }
    }

    if (!exists) {
        return {
            name: "Not Found"
        };
    }
}
